import React from 'react';
const TableMeasureRowContext = React.createContext(false);
export default TableMeasureRowContext;
